import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable, of, switchMap, take } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {AuthService} from '@core/auth/auth.service';

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService) {}

  canActivate(): Observable<boolean> {
    return this.authService.refreshAuthenticatedUser().pipe(
      take(1),
      catchError(_err => of(null)),
      switchMap(user => (
        user
          ? this.authService.redirectToDashboard().pipe(map(_ => true))
          : of(true)
      ))
    );
  }
}
